import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,

    StatusBar,
    TouchableOpacity,
    KeyboardAvoidingView,
    ImageBackground,
    ActivityIndicator, Linking,
    Text
} from "react-native";


import {scale, moderateScale, verticalScale} from '../../../../tools/Scaling';

import Colors from "../../../../tools/Colors";

import HMActionBar from "../../../../customviews/HMActionBar";

import i18n from '../../../../I18n/i18n.js';

//import HMImageBackground from "../../../../customviews/HMImageBackground";
import store from "../../../../redux/store";


import HMImageView from "../../../../customviews/HMImageView";
import DetailsAdapter from "./adapter/DetailsAdapter";
import HMTextView from "../../../../customviews/HMTextView";

const SLIDER_1_FIRST_ITEM = 1;
//import HTML from "react-native-render-html";
import {typeExport} from "../../../../redux/store/type";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import * as NavigationService from "../../../../redux/NavigationService";
import {Tools} from "../../../../tools/Tools";

import HMDetailsMap from "../../../../customviews/HMDetailsMap";
import HMIcon from "../../../../customviews/HMIcon";
import HTML from "../../../../customviews/renderHtmal/HTML";
//import HMVideoOrginal from "../../../../customviews/HMVideoOrginal";

let container = null;

export default class DetailsScreen extends Component {


    constructor(props) {
        super(props);
        container = this;
        let viewportWidth = 1;
        let viewportHeight = 1;
        if (Platform.OS === "web") {
            viewportWidth = document.body.clientWidth;
            viewportHeight = document.body.clientHeight;


        }
        this.state = {
            slider1ActiveSlide: SLIDER_1_FIRST_ITEM,
            isFull: false,
            modalHeight: 0,
            ddd: [
                "The min size must be a number.",
                "The min size must be less than 4.",
                "The max size must be a number."
            ],
            viewportWidth: viewportWidth,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 600 ? 600 : viewportWidth) : typeExport._WIDTH,


        };

    }

    componentWillReceiveProps(propss) {


    }

    showDialogUpdateApp() {
        this.setState({showDialogUpdateAppCustomize: true})
    }

    componentDidMount() {
        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;


                container.setState({
                        viewportWidth: viewportWidth,
                        itemWidth: viewportWidth > 600 ? 600 : viewportWidth,
                    },
                )


            })
        this.getData()
    }

    componentWillUnmount() {
        this.props.callserviceActionRefresh()
        //Tools._RemoveConnectivity()
    }

    getData() {
        let _params = this.props.route.params;
        let _item = JSON.parse(_params.item);
        // let _item = _params.item;

        let paramss = {
            "token": this.props.DataSplashScreen.token,
            "id": _item.ID,
            "lang": i18n.locale,
            //  "link_type": global.link_type,
            "link_type": _item.link_type,
            //'tenant_id': store.getState().reducerSplashGetAllData?.City?.tenant_id,
        };

        paramss = Tools.addAllParams(paramss);
        // this.props.callService(urlGetAllData, `?lang=${i18n.locale}&token=${token}&token_fb=${token_fb}`, TypeGetAllData, 'POST', token, token_fb, imageBack)
        this.props.callService(typeExport.urlDetailsScreen, paramss, typeExport.TypeGetDetailsScreen, typeExport._GET, this.props.DataSplashScreen.token)

    }

    callFunc(value) {

        container.setState({
                isFull: value
            },
            () => {
                // alert(value)
            })
    }

    render() {
        // let data = this.props.data;
        let data = this.props.results;
        //  let {item} = this.props.route.params;
        let _params = this.props.route.params;
        let item = _params && _params.item ? JSON.parse(_params.item) : {};
        //let item = _params.item;
        //  console.log("item", item);
        const {slider1ActiveSlide} = this.state;
        // this.state.dataSource = this.props.data.results.slider;

        let HMScrollView = Platform.OS === "web" ? View : ScrollView;
        return (
            <View style={{width: "100%", height: "100%",}}>

                {/*
                <HMImageBackground

                />*/}


                <KeyboardAvoidingView style={{width: "100%", height: "100%",}} behavior={"padding"}
                                      enabled={Platform.OS === "ios"}>
                    <HMActionBar
                        back
                        menu
                        props={this.props} statusBarTransparent
                        // text={i18n.t('main.title')}
                        text={i18n.t('constant.Details')}

                        headerVisibility={!this.state.isFull}
                        more_menu
                        onBackPress={() => this.props.navigation.pop()}


                    />


                    <View style={{flex: 1}}>
                        <View style={{height: this.state.itemWidth / 1.6, width: '100%'}}>
                            {
                                item.video ?
                                    null
                                    /*
                                                                            <HMVideoOrginal
                                                                                title={""}
                                                                                navigation={this.props.navigation} item={item} index={item.index}
                                                                                indexSelect={this.state.slider1ActiveSlide}
                                                                                path={item.video }
                                                                                callFunc={this.callFunc}
                                                                            />*/
                                    :
                                    <HMImageView
                                        //text={"1398/05/12"}
                                        // text={item.modified}
                                        resizeMode={"contain"}
                                        _backgroundColor={'rgba(0,0,0,0.99)'}
                                        styleText={{
                                            //marginHorizontal: moderateScale(5),
                                            paddingHorizontal: moderateScale(6),
                                            fontSize: moderateScale(14),
                                            color: Colors.white,
                                        }}
                                        //uriComplete={"https://static1.shomanews.com/thumbnail/jE3MGQyZjU5N/BGmQaTBpfAytX4aLRhq9RbqrRcyfllF728-Ua012PpHlttBjvNVHIOWUK_j-ZJzN1gDYrWUUxpJ8csm-_V9yRCNcdp1QsQZ6TrmyegZ6ZKdGbhQgGpNJVg,,/jE3MGQyZjU5N.jpg"}
                                        uriComplete={item.images?.file}

                                        onLoad={(e) => {
                                        }}
                                    />
                            }

                            <View
                                style={{
                                    flexDirection: 'row',
                                    position: 'absolute',
                                    bottom: 0,
                                    backgroundColor: 'rgba(0,0,0,0.4)',
                                    width: '100%',
                                    alignItems: 'center'
                                }}>
                                <View style={{}}>
                                    <HMTextView
                                        text={item.modified}
                                        // text={"امیر علی اکبری متولد سال ۱۳۶۶، قهرمان حال حاضر سنگین وزن مسابقات mma و قهرمان سابق کشتی فرنگی جهان می‌باشد."}

                                        type={'bold'}
                                        style={{
                                            // alignSelf: 'center',
                                            //  marginRight: moderateScale(6),
                                            // margin: moderateScale(6),
                                            //  textAlign: 'center',
                                            color: Colors.white,
                                            fontSize: moderateScale(14),
                                            margin: moderateScale(6)
                                        }}/>
                                </View>

                                <View style={{flex: 1}}/>
                                <View style={{flexDirection: 'row'}}>
                                    {
                                        item.details && item.details.latitude && item.details.latitude != null ?


                                            <TouchableOpacity
                                                onPress={() => {
                                                    NavigationService.navigateParams("ShowMap", {
                                                        showPlace: true,
                                                        position: {
                                                            coords: {
                                                                latitude: item.details.latitude,
                                                                longitude: item.details.longitude
                                                            }
                                                        }
                                                    })
                                                }}
                                                style={{

                                                    height: moderateScale(34),
                                                    width: moderateScale(34),
                                                    borderRadius: moderateScale(17),
                                                    backgroundColor: Colors.colorPrimary,
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    margin: moderateScale(2),
                                                    //   display: item.details.latitude && item.details.latitude != null ? null : 'none'

                                                }}>


                                                <View style={{
                                                    //flex: .3,
                                                    flexDirection: 'row',

                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}>
                                                    <HMIcon name={"md-pin"} style={{
                                                        alignSelf: 'center',
                                                        // width: moderateScale(14),
                                                        color: Colors.white,
                                                        fontSize: Platform.OS === 'ios' ? moderateScale(20) : moderateScale(16),
                                                        textAlign: 'center'
                                                    }}/>
                                                </View>


                                            </TouchableOpacity>
                                            :
                                            null
                                    }
                                    {
                                        item.details && item.details.phone ?


                                            <TouchableOpacity
                                                onPress={() => {
                                                    Tools.GoLink(item.details.phone, 'phone')
                                                }}
                                                style={{
                                                    // position: 'absolute',
                                                    // bottom: 0,
                                                    // right: 0,
                                                    height: moderateScale(34),
                                                    width: moderateScale(34),
                                                    borderRadius: moderateScale(17),
                                                    backgroundColor: Colors.colorPrimary,

                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    margin: moderateScale(2),
                                                    // display: item.details.latitude && item.details.latitude != null ? null : 'none'

                                                }}>


                                                <View style={{
                                                    //flex: .3,
                                                    flexDirection: 'row',

                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}>
                                                    <HMIcon name={"md-call"} style={{
                                                        alignSelf: 'center',
                                                        // width: moderateScale(14),
                                                        color: Colors.white,
                                                        fontSize: Platform.OS === 'ios' ? moderateScale(20) : moderateScale(16),
                                                        textAlign: 'center'
                                                    }}/>
                                                </View>


                                            </TouchableOpacity>
                                            :
                                            null
                                    }
                                </View>

                            </View>
                        </View>
                        <ScrollView style={{flex: 1}}>
                            <View style={{flex: 1}}>

                                {
                                    Platform.OS !== "web" ?
                                        <HMDetailsMap
                                            position={item.details}/>

                                        :
                                        null
                                }
                                <View
                                    style={{
                                        //flexDirection: 'row',
                                        flexWrap: 'wrap',
                                        flex: 1,

                                    }}>
                                    <HMTextView
                                        text={item.title}
                                        // text={"امیر علی اکبری متولد سال ۱۳۶۶، قهرمان حال حاضر سنگین وزن مسابقات mma و قهرمان سابق کشتی فرنگی جهان می‌باشد."}

                                        type={'bold'}
                                        style={{
                                            // alignSelf: 'center',
                                            //  marginRight: moderateScale(6),
                                            // margin: moderateScale(6),
                                            //  textAlign: 'center',
                                            color: Colors.colorDarkText,
                                            fontSize: moderateScale(14),
                                            margin: moderateScale(6)
                                        }}/>
                                </View>
                                {
                                    this.props.NoInternetDialog ?
                                        <DialogConnectionCustomize style={{alignSelf: 'center'}}
                                                                   onPress={() => this.getData()}/> :

                                        <View style={{flex: 1}}>
                                            {
                                                data === null ?
                                                    (
                                                        <View style={{
                                                            flex: 1,
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        }}>
                                                            {/*   {
                                                            this.props.NoInternetDialog === true ?
                                                                <DialogConnectionCustomize
                                                                    show={this.props.NoInternetDialog}
                                                                    onPress={() => this.getData()}
                                                                /> :
                                                                null
                                                        }*/}

                                                            <ActivityIndicator color={Colors.colorPrimary}
                                                                               size={"large"}/>
                                                        </View>
                                                    )

                                                    :

                                                    <HMScrollView
                                                        style={{
                                                            backgroundColor: "transparent",
                                                            padding: moderateScale(5),
                                                            flex: 1,

                                                            //flexDirection:'row'
                                                        }}
                                                    >
                                                        <View
                                                            style={{
                                                                flexDirection: 'row',
                                                                flex: 1,
                                                                alignItems: 'center'
                                                            }}>
                                                            {
                                                                Platform.OS === "web" ?
                                                                    <div
                                                                        dangerouslySetInnerHTML={{__html: `${data.result.content}`}}
                                                                        style={{
                                                                            //flex: 1,
                                                                            //height: 400,
                                                                            //      paddingVertical: moderateScale(10),
                                                                            minHeight: "unset",
                                                                            fontFamily: typeExport.regularFontName,
                                                                            fontSize: moderateScale(13),

                                                                        }

                                                                        }

                                                                    />
                                                                    :
                                                                    <HTML
                                                                        html={
                                                                            // "<style>p{text-align:justify}</style>" +

                                                                            `${data.result.content}`
                                                                        }
                                                                        /*                                                     html={
                                                                                                                                                // "<style>p{text-align:justify}</style>" +

                                                                                                                                 "<html dir=\"rtl\" lang=\"\"><body dir=\"rtl\">" + data.result.content + "</body></html>"
                                                                                                                                            }*/

                                                                        style={{
                                                                            //  justifyContent: "flex-end",
                                                                            //   alignItems: "flex-start",
                                                                            //flexDirection:'row'
                                                                            backgroundColor: "#21ee14",
                                                                            direction: 'rtl',


                                                                        }}
                                                                        onLinkPress={(evt, href) => {
                                                                            Linking.openURL(href);
                                                                        }}
                                                                        imagesMaxWidth={this.state.itemWidth}
                                                                        tagsStyles={{a: {color: Colors.colorPrimary,}}}
                                                                        baseFontStyle={{
                                                                            //flexDirection:"row-reverse",
                                                                            fontFamily: typeExport.regularFontName,
                                                                            fontSize: moderateScale(13),
                                                                            color: Colors.colorDark,
                                                                            lineHeight: moderateScale(30),
                                                                            //  textAlign: Platform.OS==="ios" ? 'justify' : 'right',
                                                                            textAlign: 'justify',
                                                                            writingDirection: 'rtl',

                                                                            direction: 'rtl',
                                                                        }}
                                                                        // classesStyles={{textAlign:'justify', writingDirection:'rtl'}}

                                                                        //  containerStyle={{textAlign:'justify', writingDirection:'rtl'}}
                                                                        // ignoredStyles={['font-family', 'display','text-align','height', 'width']}
                                                                        ignoredStyles={['height', 'width']}
                                                                        //allowedStyles={["none","flex"]}
                                                                    />

                                                            }


                                                        </View>

                                                    </HMScrollView>
                                            }

                                        </View>
                                }

                            </View>
                        </ScrollView>

                        {/*{
                                this.props.isLoading ?
                                    <DialogLoadingCustomize/>
                                    : null
                            }*/}
                    </View>

                </KeyboardAvoidingView>

            </View>
        );
    }

    renderItems = ({item, index}) => {
        return <DetailsAdapter
            item={item}
            index={index}
            navigation={this.props.navigation}
            props={this.props.route.params}/>;
    }


}
